
export default (totalPages) => new Array(totalPages).fill().map((_, index) => `${index + 1}`);